import { render } from "./maintenanceEquipment.vue?vue&type=template&id=2b034a68&scoped=true"
import script from "./maintenanceEquipment.vue?vue&type=script&lang=js"
export * from "./maintenanceEquipment.vue?vue&type=script&lang=js"

import "./maintenanceEquipment.vue?vue&type=style&index=0&id=2b034a68&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b034a68"]])

export default __exports__